export const customDropdownStyles = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#9a3a83' : state.isFocused ? '#EFACDE' : 'white',
        color: state.isSelected || state.isFocused ? 'white' : 'black',
        cursor: "pointer",
        fontFamily: 'Nunito, sans-serif',
        fontSize: '14px',
    }),
    control: (provided) => ({
        ...provided,
        borderColor: '#ccc',
        boxShadow: 'none',
        '&:hover': { borderColor: '#999' },
        cursor: "pointer",
        fontFamily: 'Nunito, sans-serif',
    }),
    menu: (base) => ({
        ...base,
        zIndex: 999999,
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 999999,
        fontFamily: 'Nunito, sans-serif',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#333',
        cursor: "pointer",
        fontFamily: 'Nunito, sans-serif',
    }),
    placeholder: (base) => ({
        ...base,
        width: "100%",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    }),
};